import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { pricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import { StrategyCollectionPricingPageTemplate } from "@/templates/collections/strategy/pricing/strategy-collection-pricing-page.template.tsx";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface StrategyCollectionPricingPageRelayProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef: PreloadedQuery<typeof pricingPageRelayQuery>;
}

export const StrategyCollectionPricingPageRelay = (
    props: StrategyCollectionPricingPageRelayProps
) => {
    const { pricingContent, pricing, countryCode, queryRef } = props;

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProviderRelay
            productId="strategy-collection"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <StrategyCollectionPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
